import { useQuery, keepPreviousData } from "@tanstack/react-query";
import qs from "qs";
import { getReferences } from "../api";

const referencesKeys = {
  all: ["references"],
  lists: () => [...referencesKeys.all, "referenceslist"],
  referenceslist: (filters) => [...referencesKeys.lists(), filters],
  detail: (id) => [...referencesKeys.referenceslist(), id],
};

export const useReferencesQuery = ({
  isReferencesList,
  debouncedText,
  pagination,
  sorting,
  id,
  type,
  status,
}) => {
  let params = {};
  if (debouncedText) {
    params = { ...params, search: debouncedText };
  }
  if (id) {
    params = { ...params, id: id };
  }
  if (type) {
    params = { ...params, type: type };
  }
  if (status) {
    params = { ...params, status: status };
  }
  if (sorting?.length > 0) {
    const sortByParams = sorting.reduce(
      (obj, item) =>
        Object.assign(obj, { [item.id]: item.desc ? "desc" : "asc" }),
      {}
    );
    params = {
      ...params,
      sort: sortByParams,
    };
  }
  const query = {
    params,
    paramsSerializer: (params) => qs.stringify(params, { encode: true }),
  };

  const referencesListQuery = useQuery({
    queryKey: referencesKeys.referenceslist({ query, pagination }),
    queryFn: () => getReferences({ query, pagination }),
    placeholderData: keepPreviousData,
    enabled: isReferencesList,
  });

  return {
    referencesListQuery,
  };
};
